
import { defineComponent, ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import AddCrmDrawer from "@/layout/extras/AddCrmDrawer.vue";

import MerchantApiCard from "@/components/merchants/details/MerchantApiCard.vue";
import ApiService from "@/core/services/ApiService";
import AddApiDrawer from "@/layout/extras/AddApiDrawer.vue";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import UpdateApiDrawer from "@/layout/extras/UpdateApiDrawer.vue";
import { MenuComponent } from "@/assets/ts/components";

interface Endpoint {
  id: string;
  connection_id: string;
  endpoint_name: string;
  method: string;
  custom_host: string;
  endpoint_path: string;
  enabled: string;
  endpoint_status: string;
  parameters: string;
  created: string;
  modified: string;
}

interface Connection {
  id: string;
  conn_name: string;
  scheme: string;
  host: string;
  domain: string;
  auth_type: string;
  payload_type: string;
  response_type: string;
  enabled: string;
  conn_status: string;
  category: string;
  created: string;
  modified: string;
  logo_url: string;
}

export default defineComponent({
  name: "merchant-apis",
  components: {
    MerchantApiCard,
    AddApiDrawer,
    UpdateApiDrawer,
    AddCrmDrawer,
  },
  setup() {
    const curPage = ref(1);
    const rowsPerPage = 9;
    const curRows = ref(0);
    const total = ref(0);
    const apis = ref([]);
    const loading = ref(false);
    const route = useRoute();
    const endpoints = ref<Endpoint[]>([]);
    const connections = ref<Connection[]>([]);
    const selectedGroup = ref("All");
    const selectedApi = ref({});

    const getMerchantId = computed(() => {
      return route.params.id;
    });

    onMounted(async () => {
      setTimeout(async () => {
        const { data } = await ApiService.get(`apis/endpoints?limit=100`);
        endpoints.value = data.data;

        const res = await ApiService.get(`apis/connections?limit=100`);
        connections.value = res.data.data;

        getApis();
        DrawerComponent.reinitialization();
      }, 1000);
    });

    const reInitializeMenus = () => {
      setTimeout(() => {
        MenuComponent.reinitialization();
      }, 0);
    };

    const getApis = async () => {
      loading.value = true;

      try {
        const offset = (curPage.value - 1) * rowsPerPage;

        let url;
        if (selectedGroup.value === "All") {
          url = `apis/merchants?offset=${offset}&limit=${rowsPerPage}&merchant_id=${getMerchantId.value}&group[category]=Gateway,Crm`;
        } else {
          url = `apis/merchants?offset=${offset}&limit=${rowsPerPage}&merchant_id=${getMerchantId.value}&group[category]=${selectedGroup.value}`;
        }

        const { data } = await ApiService.get(url);

        curRows.value = data.data.length;
        total.value = data.meta.total;

        apis.value = data.data.map((api) => {
          api.endpoint = endpoints.value.find(
            (endpoint) => endpoint.id === api.endpoint_id
          );
          api.connection = connections.value.find(
            (conn) => conn.id === api.connection_id
          );

          return api;
        });

        reInitializeMenus();
      } catch (err) {
        apis.value = [];
        total.value = 0;
        curPage.value = 1;
        curRows.value = 0;
      }

      loading.value = false;
    };

    const currentPageChange = (val) => {
      curPage.value = val;
      getApis();
    };

    const onNewApiSubmit = () => {
      getApis();
    };

    const onNewCrmSubmit = () => {
      getApis();
    };
    const selGroup = () => {
      curPage.value = 1;
      getApis();
    };

    const editAPI = async (val) => {
      selectedApi.value = val;
      if (val.connection_id === "1" && val.endpoint_id === "1") {
        const parameters = JSON.parse(val.parameters);
        await getProcs(parameters.username, parameters.password);
      }

      DrawerComponent?.getInstance("update_api_drawer")?.show();
    };

    const onUpdateApiSubmit = () => {
      getApis();
    };

    const getIsDataEmpty = computed(() => {
      if (total.value === 0) {
        return true;
      }

      return false;
    });

    const procs = ref([]);
    const getProcs = async (username, password) => {
      try {
        const res = await ApiService.get(
          `apis/merchants?action=nmi_processor&username=${username}&password=${password}`
        );
        if (res.data.success) {
          procs.value = res.data.data[0];
        } else {
          procs.value = [];
        }
      } catch (e) {
        procs.value = [];
      }
    };

    return {
      curPage,
      rowsPerPage,
      curRows,
      total,
      apis,
      currentPageChange,
      onNewCrmSubmit,
      loading,
      onNewApiSubmit,
      selectedGroup,
      selGroup,
      editAPI,
      getApis,
      selectedApi,
      onUpdateApiSubmit,
      getIsDataEmpty,
      procs,
    };
  },
});
